export enum AuthenticationProviders {
  IDAM = "IDAM",
}
